import React from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import logo from '../images/logo_1.png';
import HeaderComponent from './HeaderComponent';
import '../styles/Home.css'
import TablaInventario from './TablaInventario';

const Home = ({ onProcess }) => {

    return (
        <>
            <HeaderComponent title={"Home"} />
            <div className='col-12 ml-6' style={{ minWidth:"95%", maxWidth:"95%" }}>
                <div className='ml-2' style={{ fontSize:"20px" }}>
                    <p>
                        Bienvenid@ al Home
                        
                    </p>
                </div>
                {/* <Button label="Procesar Pedido" icon="pi pi-check" onClick={onProcess} /> */}

            </div>
        </>
    );
};

export default Home;
